module.exports = __webpack_public_path__ + "img/sun.77046612.png";